import _extends from "@babel/runtime/helpers/extends";
export const setSsrDataPromise = slice => slice.promise === null ? _extends({}, slice, {
  promise: Promise.resolve(slice.data)
}) : slice;